import React, { useEffect, Fragment } from "react";
//import ReactDOMServer from "react-dom/server";
import ReactDOM from "react-dom";

import { MARKER_GREEN_URL } from "../../config";

export default function Marker(props) {
  const { infoWindow } = props;
  const infoWindowPortal = document.createElement("div");

  useEffect(() => {
    const { map, position, options, defaultOpen } = props;

    if (!!map && !!position) {
      const marker = new window.google.maps.Marker({
        position,
        map,
        icon: MARKER_GREEN_URL,
        ...options
      });

      if (!!infoWindow) {
        const infowindow = new window.google.maps.InfoWindow({
          //content: ReactDOMServer.renderToStaticMarkup(infoWindow)
          content: infoWindowPortal
        });

        //open info window after loading
        defaultOpen && infowindow.open(map, marker);

        marker.addListener("click", function() {
          infowindow.open(map, marker);
        });
      }
    }
  }, [props, infoWindowPortal, infoWindow]);

  return (
    <Fragment>
      {!!infoWindowPortal && !!infoWindow
        ? ReactDOM.createPortal(infoWindow, infoWindowPortal)
        : null}
    </Fragment>
  );
}
